import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ErrorPage from "../pages/ErrorPage";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="grid min-h-screen place-items-center bg-ink text-barberGold">CARGANDO PORTAS BARBER SHOP…</div>;
  return user ? children : <Navigate to="/login" replace state={{ from: location }} />;
}

export function RoleProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  if (!roles.includes(user?.rol)) return <ErrorPage code={403} title="No tienes permisos para acceder" detail="Tu rol no permite ingresar a esta sección." />;
  return children;
}
